import React from 'react';
import { CameraAlt } from '@mui/icons-material';
import AddHeader from '../../../../../components/layout/header/add';
import Form from '../../../../../components/molecules/forms';
import usePartnersContactPerson from './hooks';
import PartnersEditBottomButton from '../bottom-button';

interface Props {
  // eslint-disable-next-line react/require-default-props
  contactId?: number;
  // eslint-disable-next-line react/require-default-props
  formikParent? : any;
}

function PartnersContactPerson(props: Props) {
  const { contactId, formikParent } = props;
  const {
    formik, partner, partnerId, contactPersonById, isEdit, updateLoad,
  } = usePartnersContactPerson(contactId, formikParent);

  const renderFormContent = () => (
    <div>
      {isEdit && (
      <AddHeader
        primary={{ route: '/partners', title: 'Partner' }}
        secondary={{
          route: `/partners/${partnerId}`,
          title: contactPersonById?.firstname && contactPersonById?.lastname
            ? `${contactPersonById.firstname} ${contactPersonById.lastname}` : undefined,
        }}
        title="Edit Contact Person Detail"
      />
      )}
      <div className="px-4 px-xl-5 mb-5">
        <div className="fw-bold fz-16 mb-4">{`${partnerId ? 'Edit' : 'Add'} Contact Person Detail`}</div>
        <div className="mb-5 d-flex justify-content-center">
          <div className="camera-container w-100 rounded-circle ratio ratio-1x1 flexible-center">
            <div className="flexible-center flex-column">
              <CameraAlt sx={{ fontSize: 50, color: '#18266D' }} />
              <div className="text-secondary">Min size: 188 by 264</div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-6">
            <Form.Default
              id="firstname"
              placeholder="Enter First Name"
              label="First Name"
              className="mb-4"
              value={formik.values.firstname}
              onChange={formik.handleChange}
              isInvalid={!!formik.errors.firstname && formik.touched.firstname}
              errorMsg={formik.errors.firstname}
              onBlur={formik.handleBlur}
              disabled={partner.isLoading}
            />
          </div>
          <div className="col-lg-6">
            <Form.Default
              id="lastname"
              placeholder="Enter Last Name"
              className="mb-4"
              label="Last Name"
              value={formik.values.lastname}
              onChange={formik.handleChange}
              isInvalid={!!formik.errors.lastname && formik.touched.lastname}
              errorMsg={formik.errors.lastname}
              onBlur={formik.handleBlur}
              disabled={partner.isLoading}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-lg-6">
            <Form.Default
              id="email"
              placeholder="Enter Email Address"
              className="mb-4"
              label="Email Address"
              value={formik.values.email}
              onChange={formik.handleChange}
              isInvalid={!!formik.errors.email && formik.touched.email}
              errorMsg={formik.errors.email}
              onBlur={formik.handleBlur}
              disabled={partner.isLoading}
            />
          </div>
          <div className="col-lg-6">
            <Form.Default
              id="phoneNumber"
              placeholder="Enter Phone Number"
              className="mb-4"
              label="Phone Number"
              value={formik.values.phoneNumber}
              onChange={formik.handleChange}
              isInvalid={!!formik.errors.phoneNumber && formik.touched.phoneNumber}
              errorMsg={formik.errors.phoneNumber}
              onBlur={formik.handleBlur}
              disabled={partner.isLoading}
            />
          </div>
        </div>
        <Form.Default
          id="position"
          placeholder="Enter Position"
          className="mb-4"
          label="Position"
          value={formik.values.position}
          onChange={formik.handleChange}
          isInvalid={!!formik.errors.position && formik.touched.position}
          errorMsg={formik.errors.position}
          onBlur={formik.handleBlur}
          disabled={partner.isLoading}
        />
      </div>
      <div className={isEdit ? 'w-100 bg-stroke mb-4' : 'd-none'} style={{ height: '7px' }} />
      {partnerId && <PartnersEditBottomButton isLoading={updateLoad} isEdit={isEdit} />}
    </div>
  );

  if (formikParent) return renderFormContent();
  return (
    <form onSubmit={formik.handleSubmit}>
      {renderFormContent()}
    </form>
  );
}

export default PartnersContactPerson;
